export function Spinner({ size = 48 }: { size?: number }) {
  return (
    <div
      style={{ width: size, height: size }}
      className="animate-spin rounded-full h-8 w-8 border-b-2 border-red-500 mx-auto mb-4"
    />
  )
}
